import React, { useState } from "react";

const SocialEfforts = () => {
  const [selectedCategory, setSelectedCategory] = useState("Environment");

  const categories = [
    "Environment",
    "Health",
    "Education",
    "Skill Development",
  ];

  const objectivesData = [
    {
      title: "Sustainable Social Model",
      description: "Build a sustainable social model through comprehensive CSR programs, guided by measurable outcomes.",
      icon: <img src="/image/eco.png" alt="Sustainable Icon" style={{ width: '54px', height: '54px' }} />,
      color: "#4CAF50"
    },
    {
      title: "Technological Interventions",
      description: "Address social challenges through innovative technological interventions, creating solutions to pressing issues.",
      icon: <img src="/image/tech.png" alt="Sustainable Icon" style={{ width: '64px', height: '64px' }} />,
      color: "#2196F3"
    },
    {
      title: "Collaborative Partnerships",
      description: "Collaborate with implementation partners to execute targeted social interventions in key thematic areas.",
      icon: <img src="/image/partner.png" alt="Sustainable Icon" style={{ width: '64px', height: '64px' }} />,
      color: "#FF9800"
    }
  ];

  const effortsData = {
    Environment: {
      title: "Environmental Initiatives",
      description: "We are committed to sustainable environmental practices and initiatives that contribute to a greener planet.",
      details: [
        "Ecosystem restoration projects in partnership with local communities",
        "Promoting sustainable agriculture practices to reduce environmental impact",
        "Implementing circular economy principles across our operations",
        "Reducing carbon footprint through renewable energy adoption",
        "Water conservation and watershed management programs"
      ],
      image: "/image/Simple_Environment.jpeg",
    },
    Health: {
      title: "Healthcare Programs",
      description: "Our health initiatives focus on improving community wellbeing and healthcare accessibility.",
      details: [
        "Mobile health clinics serving remote communities",
        "Disease prevention and vaccination campaigns",
        "Maternal and child health programs",
        "Mental health awareness and support services",
        "Partnerships with local healthcare providers to improve access"
      ],
      image: "/image/health.avif",
    },
    Education: {
      title: "Educational Outreach",
      description: "Education is the cornerstone of personal growth, societal progress, and economic prosperity.",
      details: [
        "Scholarship programs for underprivileged students",
        "Digital literacy initiatives in rural schools",
        "Teacher training and capacity building programs",
        "School infrastructure development projects",
        "STEM education programs to foster innovation"
      ],
      image: "/image/Education-in-India.jpg",
    },
    "Skill Development": {
      title: "Skill Development Programs",
      description: "We empower individuals with skills needed for professional growth and economic independence.",
      details: [
        "Vocational training centers offering certified courses",
        "Entrepreneurship development and mentorship programs",
        "Digital skills training for the modern workforce",
        "Apprenticeship opportunities with industry partners",
        "Career counseling and job placement support"
      ],
      image: "/image/skill.jpg",
    },
  };

  return (
    <div className="social-efforts-container">
      <style>
        {`
          .social-efforts-container {
            font-family: 'Segoe UI', Arial, sans-serif;
            background-color: white;
          }

          .csr-title {
            font-size: 26px;
            font-weight: 700;
            color: #0a3d58;
            margin-bottom: 6px;
            padding-top: 22px;
            letter-spacing: 0.3px;
            text-align: center;
          }

          .objectives-section {
            padding: 34px 20px;
            background: white;
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .objectives-inner {
            max-width: 1150px;
            width: 100%;
          }

          .objectives-heading {
            font-size: 20px;
            color: #0a3d58;
            margin-bottom: 16px;
            text-align: left;
            font-weight: 700;
            letter-spacing: 0px;
          }

          .objectives-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
            gap: 18px;
            margin-bottom: 6px;
          }

          .objective-card {
            background: #ffffff;
            border-radius: 10px;
            padding: 20px 18px;
            box-shadow: 0 3px 14px rgba(0, 0, 0, 0.07);
            transition: transform 0.25s ease, box-shadow 0.25s ease;
            display: flex;
            flex-direction: column;
            height: 100%;
            border-top: 3px solid;
          }

          .objective-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
          }

          .objective-icon {
            margin-bottom: 12px;
            text-align: center;
          }

          .objective-title {
            font-size: 15px;
            font-weight: 700;
            margin-bottom: 8px;
            color: #0a3d58;
            letter-spacing: 0.2px;
          }

          .objective-description {
            color: #5b6270;
            line-height: 1.5;
            text-align: left;
            font-size: 13px;
            margin: 0;
          }

          .social-efforts {
            padding: 30px 20px 50px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          .content-container {
            max-width: 1150px;
            width: 100%;
            text-align: left;
            padding: 16px;
          }

          .social-efforts h1 {
            font-size: 20px;
            color: #0a3d58;
            margin-bottom: 10px;
            letter-spacing: 0px;
            text-align: left;
            font-weight: 700;
          }

          .intro-text {
            font-size: 13.5px;
            color: #5b6270;
            margin-bottom: 26px;
            text-align: left;
            line-height: 1.6;
            max-width: 800px;
          }

          .filters {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 28px;
            flex-wrap: wrap;
            gap: 10px;
          }

          .filter-button {
            background-color: #f8f9fa;
            border: 1.5px solid #e9ecef;
            padding: 9px 18px;
            cursor: pointer;
            transition: all 0.25s ease;
            border-radius: 6px;
            font-weight: 600;
            font-size: 13px;
            color: #495057;
          }

          .filter-button:hover {
            background-color: #e9ecef;
            transform: translateY(-1px);
          }

          .filter-button.active {
            background-color: #0a3d58;
            color: white;
            border-color: #0a3d58;
          }

          .efforts-container {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            width: 100%;
            gap: 36px;
          }

          .efforts-content {
            flex: 1;
          }

          .efforts-content h2 {
            color: #0a3d58;
            margin-bottom: 10px;
            font-size: 17px;
            letter-spacing: 0px;
            font-weight: 700;
          }

          .efforts-content p {
            color: #5b6270;
            font-size: 13.5px;
            text-align: left;
            line-height: 1.6;
            margin-bottom: 16px;
          }

          .details-list {
            margin-left: 18px;
            margin-bottom: 0;
            padding: 0;
          }

          .details-list li {
            margin-bottom: 8px;
            line-height: 1.5;
            color: #495057;
            font-size: 13px;
          }

          .image-container {
            flex-shrink: 0;
            max-width: 40%;
          }

          .efforts-image {
            width: 100%;
            height: 260px;
            object-fit: cover;
            border-radius: 10px;
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
            transition: transform 0.3s ease;
            display: block;
          }

          .efforts-image:hover {
            transform: scale(1.02);
          }

          @media (max-width: 992px) {
            .efforts-container {
              flex-direction: column;
              align-items: center;
              gap: 22px;
            }

            .image-container {
              max-width: 70%;
              order: -1;
            }

            .efforts-image {
              height: 220px;
            }

            .objectives-grid {
              grid-template-columns: 1fr;
            }
          }

          @media (max-width: 768px) {
            .social-efforts, .objectives-section {
              padding: 26px 15px;
            }

            .csr-title {
              font-size: 22px;
            }

            .social-efforts h1, .objectives-heading {
              font-size: 18px;
            }

            .filters {
              justify-content: center;
            }

            .filter-button {
              padding: 8px 14px;
              font-size: 12.5px;
            }

            .image-container {
              max-width: 100%;
            }

            .efforts-image {
              height: 200px;
            }

            .efforts-content h2 {
              font-size: 16px;
            }

            .efforts-content p {
              font-size: 13px;
            }

            .objective-card {
              padding: 16px;
            }

            .objective-title {
              font-size: 14px;
            }

            .objective-description {
              font-size: 12.5px;
            }
          }

          @media (max-width: 576px) {
            .filters {
              flex-direction: column;
              width: 100%;
            }

            .filter-button {
              width: 100%;
              margin-bottom: 8px;
            }

            .efforts-image {
              height: 180px;
            }
          }
        `}
      </style>

      {/* CSR Title */}
      <div className="csr-title">CSR (Corporate Social Responsibility)</div>

      {/* Objectives Section */}
      <section className="objectives-section">
        <div className="objectives-inner">
          <h2 className="objectives-heading">Our Objectives</h2>
          <div className="objectives-grid">
            {objectivesData.map((objective, index) => (
              <div
                key={index}
                className="objective-card"
                style={{ borderTopColor: objective.color }}
              >
                <div className="objective-icon">{objective.icon}</div>
                <h3 className="objective-title">{objective.title}</h3>
                <p className="objective-description">{objective.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Social Efforts Section */}
      <section className="social-efforts">
        <div className="content-container">
          <h1>Our Social Efforts</h1>
          <p className="intro-text">
            As part of our commitment to social responsibility, we focus on key
            areas such as Environment, Health, Education and Skill Development.
            Through these initiatives, we aim to create sustainable value for
            communities and contribute to a more equitable society.
          </p>

          <div className="filters">
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-button ${category === selectedCategory ? "active" : ""}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="efforts-container">
            <div className="efforts-content">
              <h2>{effortsData[selectedCategory].title}</h2>
              <p>{effortsData[selectedCategory].description}</p>

              <ul className="details-list">
                {effortsData[selectedCategory].details.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="image-container">
              <img
                src={effortsData[selectedCategory].image}
                alt={`${selectedCategory} Image`}
                className="efforts-image"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SocialEfforts;